module.exports = __webpack_public_path__ + "img/moon.9b75d130.jpg";